import { __assign } from "tslib";
import React from 'react';
import FullscreenMobileBar from './FullscreenMobileBar';
import FullscreenSidebar from './fullscreenSidebar.js';
import FullscreenShareScreen from './fullscreenShareScreen.js';
import ProGallerySlider from './ProGallerySlider';
import MobileZoom from './MobileZoom';
import MobileBottomLink from './mobileBottomLink';
import { utils } from '../utils';
import { fullscreenRenderer, sidebarRenderer, renderSlider, } from './expandUtils';
import { getBaseStyles } from './proGallerySliderFixedStyles';
import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
import { Consts } from '@wix/photography-client-lib';
function MobileExpand(props) {
    var getCustomInfoRenderer = function (pgItemProps) {
        var _a = props.styles, allowDescriptionExpand = _a.allowDescriptionExpand, allowTitleExpand = _a.allowTitleExpand;
        var customMobileSidebarRenderer = props.customMobileSidebarRenderer;
        var galleryAlignExpand = props.styles.galleryAlignExpand;
        var style = pgItemProps.style;
        var margin = props.container.height -
            pgItemProps.options.textBoxHeight -
            style.innerHeight; // could be a prob with text items. need to check
        var styles = {
            textAlign: galleryAlignExpand,
            height: 'fit-content',
            marginTop: -margin,
        };
        var infoElement;
        if (typeof customMobileSidebarRenderer === 'function') {
            infoElement = (React.createElement("div", { style: styles, className: 'pro-gallery-expand-info artstore-info' }, customMobileSidebarRenderer(__assign(__assign({}, props), { styleParams: props.styles, item: pgItemProps }))));
        }
        else {
            infoElement = (React.createElement("div", { style: styles, className: 'pro-gallery-expand-info' },
                allowTitleExpand && (React.createElement("div", { className: 'fullscreen-side-bar-title' },
                    React.createElement("p", null, pgItemProps.title))),
                allowDescriptionExpand && (React.createElement("div", { className: 'fullscreen-side-bar-description' },
                    React.createElement("p", null, pgItemProps.description))),
                React.createElement(MobileBottomLink, { styles: props.styles, current: props.current, actions: props.actions, noFollowForSEO: props.noFollowForSEO })));
        }
        return infoElement;
    };
    var getFullscreenShareScreen = function () {
        return React.createElement(FullscreenShareScreen, __assign({}, props));
    };
    var getTopMobileBar = function () {
        return React.createElement(FullscreenMobileBar, __assign({}, props));
    };
    var getCloseButton = function () {
        var actions = props.actions, itemClickIsOpenInFullscreen = props.itemClickIsOpenInFullscreen;
        var onClickFunction = itemClickIsOpenInFullscreen
            ? function () { return actions.closeBrowserFullscreen(true); }
            : function () { return actions.toggleFullscreen(false); };
        return props.isLandscape ? null : (React.createElement("button", { style: { zIndex: 1000 }, className: "fullscreen-icon fullscreen-toggle-zoom progallery-svg-font-icons-close-x ", onClick: onClickFunction },
            React.createElement("div", { className: "icon-background" })));
    };
    var getMobileZoom = function (initialOffset) {
        return (React.createElement(MobileZoom, { current: props.current, currentWindow: getCurrentWindowForZoom(), styles: props.styles, container: props.container, actions: props.actions, initialOffset: initialOffset, currentGalleryItem: props.currentGalleryItem, shouldShow: props.isMobileZoom }));
    };
    var getCurrentWindowForZoom = function () {
        var currentWindow = props.currentWindow, isLandscape = props.isLandscape;
        var dim = currentWindow.size;
        if (!isLandscape) {
            dim = {
                width: dim.width,
                height: dim.height - Consts.dimensions.MOBILE_PADDING,
            };
        }
        return {
            width: dim.width,
            height: dim.height,
        };
    };
    var composeFullscreen = function () {
        var isFullscreen = props.isFullscreen, hasAdditionalSidebarElement = props.hasAdditionalSidebarElement, currentWindow = props.currentWindow, styles = props.styles, container = props.container;
        var aditionalStyles = {
            slideAnimation: GALLERY_v4_CONSTS.slideAnimations.SCROLL,
            showArrows: false,
            textBoxHeight: isFullscreen ? 0 : 200,
            cubeFitPosition: isFullscreen
                ? GALLERY_v4_CONSTS.cubeFitPosition.MIDDLE
                : GALLERY_v4_CONSTS.cubeFitPosition.TOP,
        };
        var isIos = utils.isiOS();
        var slider = renderSlider({
            props: props,
            aditionalStyles: aditionalStyles,
            container: container,
            isTouchDeviceZoom: isFullscreen,
            customInfoRenderer: isFullscreen ? null : getCustomInfoRenderer,
            classNames: (isFullscreen
                ? 'pro-gallery-mobile-fullscreen'
                : 'pro-gallery-mobile-expand') + (isIos ? ' ios' : ''),
            containerPostProcess: props.isPrerenderMode ? {
                ios: {
                    height: {
                        addition: -Consts.mobileTopbarContainer.MOBILE_TOPBAR_CONTAINER,
                    }
                }
            } : null,
        });
        return [
            props.isMobileZoom ? getMobileZoom(isFullscreen ? 0 : 60) : null,
            !isFullscreen && getTopMobileBar(),
            slider,
            hasAdditionalSidebarElement ? sidebarRenderer(props) : null,
            !isFullscreen && getFullscreenShareScreen(),
            isFullscreen && getCloseButton(),
        ];
    };
    var hasAdditionalSidebarElement = props.hasAdditionalSidebarElement, isFullscreen = props.isFullscreen, setRef = props.setRef, fullscreenClasses = props.fullscreenClasses;
    return fullscreenRenderer({
        setRef: setRef,
        fullscreenClasses: fullscreenClasses,
        comp: composeFullscreen(),
        style: {},
    });
}
export default MobileExpand;
//# sourceMappingURL=MobileExpand.js.map